"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipMultilineTextStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _tooltipTheme = require("../tooltipTheme");
const TooltipMultilineTextStyled = (0, _styled.default)("div")`
    padding: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _tooltipTheme.tooltipTheme.padding.multiLine.text(themeMode);
}};

    // The distance between tooltip text siblings. The title has the gap between title and text.
    & ~ & {
        padding-top: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _tooltipTheme.tooltipTheme.padding.multiLine.textGap(themeMode);
}};
    }

    // The extra gap needed to accomodate the extra space at the bottom needed for the Lodestar
    // multiline tooltip.
    &:last-child {
        padding-bottom: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _tooltipTheme.tooltipTheme.padding.multiLine.textEndGap(themeMode);
}};
    }
`;
exports.TooltipMultilineTextStyled = TooltipMultilineTextStyled;
//# sourceMappingURL=TooltipMultilineTextStyled.js.map